import {Grid, useMediaQuery} from "@mui/material";
import React, {PropsWithChildren, useEffect, useState} from "react";
import theme from "./theme";
import {Route, Routes, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {SamaggiNavbar} from "./Components/SamaggiNavbar";
import {PaperBackdrop} from "./Components/SamaggiBackdrop";
import {Lanyard} from "./Pages/Lanyard";
import {Home} from "./Pages/Home";
import {SignIn} from "./Pages/SignIn";
import {Callback} from "./Pages/Callback";
import axios from "axios";
import {checkToken, signOut} from "./support";
import {SamaggiPageContainer} from "./Components/SamaggiPageContainer";
import {LanyardAdmin} from "./Pages/LanyardAdmin";
import {LegacyScanner} from "./Pages/LegacyScanner";
import {SSODebug} from "./Pages/SSODebug";
import {Email} from "./Pages/Email";
import {NewReimbursements} from "./Pages/NewReimbursements";
import {NewReimbursementsAdmin} from "./Pages/NewReimbursementsAdmin";
import {PostixBankTransfer} from "./Pages/PostixBankTransfer";

export interface BasicProps {
    mobile: boolean,
    vertical: boolean,
    setShowCover: React.Dispatch<React.SetStateAction<boolean>>
}

export const Main: React.FC< PropsWithChildren > = () => {
    const mobile = useMediaQuery(theme.breakpoints.down("md"));
    const vertical = useMediaQuery(theme.breakpoints.down("sm"));
    const location = useLocation();
    const navigate = useNavigate();
    const [params, ] = useSearchParams();
    const currentPath = location.pathname;

    const widePaths = [
        "/",
        "/finance-request",
        "/finance-request/manage",
        "/lanyard/manage",
        "/sso-debug",
        "/email",
        "/postix-payments"
    ]

    const noPaperOnMobile = [
        "/finance-request",
        "/finance-request/manage",
        "/lanyard/manage",
        "/email",
        "/postix-payments"
    ]

    const [showCover, setShowCover] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [name, setName] = useState("");
    const [allowedPages, setAllowedPages] = useState<Array<string>>([]);
    const [authenticating, setAuthenticating] = useState(false);

    function updateBar() {
        const token = localStorage.getItem("token");
        if (token !== null) {
            setLoggedIn(true);
            const displayName = localStorage.getItem("displayName");
            if (displayName !== null) {
                setName(displayName);
            }
        } else {
            setLoggedIn(false);
            setName("")
        }
    }

    useEffect(() => {
        updateBar()
    })

    useEffect(() => {
        console.log("Added event listener.")
        window.addEventListener("storage", () => {
            const token = localStorage.getItem("token");
            console.log("UPDATED!", token, location.pathname)
            if (location.pathname !== "/callback" && token !== null) {
                setShowCover(true);
                doTokenCheck()
            } else if (location.pathname === "/sign-in" && token === null) {
                setShowCover(false);
            }
        }) // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function doTokenCheck() {
        if (!["/sign-in", "/callback"].includes(location.pathname) && localStorage.getItem("token") !== null) {
            authenticate();
        }
        checkToken().then((valid) => {
            console.log("DO TOKEN CHECK", valid, location.search)
            // setShowCover(false);
            if (!valid && !["/sign-in", "/callback"].includes(location.pathname)) {
                const url = new URL(window.location.protocol + '//' + window.location.host + "/sign-in")

                if (location.pathname !== "/") {
                    url.searchParams.set("nav", location.pathname);
                }

                params.forEach((value, key) => {
                    if (key !== "nav" && key !== "req") {
                        url.searchParams.set(key, value);
                    }
                })

                window.location.href = url.href;
            } else if (valid && location.pathname === "/sign-in") {
                if (params.has("nav")) {
                    const cleanedParams = params;
                    const nav = (params.get("nav") as string).replace("$", "/");
                    cleanedParams.delete("nav");

                    console.log("NAV1")

                    navigate({
                        pathname: nav,
                        search: cleanedParams.toString()
                    });
                } else {
                    console.log("NAV2")

                    navigate({
                        pathname: "/",
                        search: params.toString()
                    });
                }
            } else {
                console.log("NAV3", location.pathname)
            }

            if (!["/", "/sign-in"].includes(location.pathname) && allowedPages.length !== 0 && !allowedPages.includes(location.pathname)) {
                alert("You are not allowed to access this page.");
                navigate("/");
            }
        })
    }

    useEffect(() => {
        console.log('Location changed', location.pathname);
        doTokenCheck();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    function authenticate() {
        const token = localStorage.getItem("token");

        if (authenticating || token === null) {
            return
        }
        setAuthenticating(true);

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/init/", {"token": token}).then((res) => {
            setAuthenticating(false);
            try {
                if (!res.data.data["staff"]) {
                    alert("You don't have permission to access the Staff Portal. You will be signed out.");
                    signOut();
                    navigate("/sign-in");
                } else {
                    localStorage.setItem("userData", JSON.stringify(res.data.data.data));
                    localStorage.setItem("options", JSON.stringify(res.data.data.options));
                    setName(`${res.data.data.data.name["firstName"]} ${res.data.data.data.name["lastName"]} — ${res.data.data.data.team}`)
                    console.log(res.data.data.allow);
                    setAllowedPages(res.data.data.allow);
                }
            } catch (e) {
                console.warn(e);
            }
        }).catch((error) => {
            console.warn(error)
            console.log(error["request"])
            setAuthenticating(false);
            try {
                if (error.response !== undefined) {
                    const err = error.response.data.data.reason;
                    if (err !== "Invalid Token") {
                        alert(err);
                    } else {
                        console.log("Invalid Token for Get Data");
                    }
                } else {
                    //alert(error.message);
                }
            } catch (e) {
                //alert(error.message);
                console.warn(e);
            }
        })
    }

    return (
        <>
            <SamaggiNavbar isLoading={false} name={name} isLoggedIn={loggedIn} mobile={mobile} vertical={vertical}/>
            <Grid container direction={"column"} alignItems={"center"}>
                <SamaggiPageContainer mobile={mobile} vertical={vertical} wide={widePaths.includes(currentPath)} noPad noContainer={mobile && noPaperOnMobile.includes(currentPath)}>
                    <PaperBackdrop open={showCover} noContainer={mobile && noPaperOnMobile.includes(currentPath)}>
                        <Routes>
                            <Route path="/callback" element={<Callback mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                            <Route path="/lanyard" element={<Lanyard mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                            <Route path="/lanyard/manage" element={<LanyardAdmin mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                            <Route path="/sign-in" element={<SignIn mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                            {/*<Route path="/finance-request" element={<Reimbursements mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />*/}
                            {/*<Route path="/finance-request/manage" element={<ReimbursementsAdmin mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />*/}
                            <Route path="/finance-request/manage" element={<NewReimbursementsAdmin mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                            <Route path="/finance-request" element={<NewReimbursements mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                            <Route path="/postix-scanner" element={<LegacyScanner mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                            <Route path="/" element={<Home mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                            <Route path="/sso-debug" element={<SSODebug mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                            <Route path="/email" element={<Email mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                            <Route path="/postix-payments" element={<PostixBankTransfer mobile={mobile} vertical={vertical} setShowCover={setShowCover}/>} />
                        </Routes>
                    </PaperBackdrop>
                </SamaggiPageContainer>
            </Grid>
        </>
    )
}
